import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  // { path: '', redirectTo: '/login', pathMatch: 'full' },
  // {
  //   path: 'login',
  //   loadChildren: () => import('./features/login/login.module').then(m => m.LoginModule)
  // },
  {
    path: 'home',
    loadChildren: () => import('./features/home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'planner-view/:voyageId',
    loadChildren: () => import('./features/planner-view/planner-view.module').then(m => m.PlannerViewModule)
  },
  { path: '**', loadChildren: () => import('./features/login/login.module').then(m => m.LoginModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
